import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloFromVux'
import TwoD from '@/components/TwoD'
import SetQaPage from '@/components/SetQaPage'
import ChatGPTpage from '@/components/ChatGPTpage/ChatGPTpage'
Vue.use(Router)

export default new Router({
  mode:'history',
  routes: [
    {
      path: '/ThreeD',
      name: 'HelloWorld',
      component: HelloWorld
    },
    {
      path: '/ChatGPTpage',
      name: 'ChatGPTpage',
      component: ChatGPTpage
    },
    {
      path: '/TwoD',
      name: 'TwoD',
      component: TwoD
    },
    {
      path: '/SetQaPage',
      name: 'SetQaPage',
      component: SetQaPage
    },
    {
      path: '/webglframe',
      name: 'webglframe',
      component:()=>import('@/components/WebGLFrame')
    },
    {
      path: '/webglmaindemo',
      name: 'webglmaindemo',
      component: ()=>import('@/components/WebGLMainDemo')
    },
    {
      path: '/pdfview',
      name: 'pdfview',
      component: ()=>import('@/components/PDFView')
    },
    {
      path: '/humanpreview',
      name: 'humanpreview',
      component: ()=>import('@/components/HumanPreview/HumanPreview')
    },
    {
      path: '/subCompany',
      name: 'subCompany',
      component: ()=>import('@/components/SubmitCompany/SubmitCompany')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js